import React from 'react';
import tw, { styled } from 'twin.macro';

import { Container } from '../atoms';
import { PortableText } from '../elements';
import SanityImage from '../global/SanityImage';

const Wrapper = styled.div(({ reverse }) => [
  tw`flow-root md:flex items-center justify-center md:-space-x-20`,
  reverse && tw`flex-row-reverse space-x-reverse`,
]);

const AboutBlock = (props) => {
  const { description, image, isReverse } = props;
  return (
    <Container tw="bg-slate">
      <Wrapper reverse={isReverse}>
        <div tw="space-y-4  bg-white px-4 py-4 md:px-10 md:py-14  w-full md:w-2/5 z-10 md:-space-x-20">
          <PortableText>{description}</PortableText>
        </div>
        <div tw="w-full md:w-3/5 md:-space-x-20">
          {image.asset && (
            <SanityImage
              gatsbyImageId={image.asset.id}
              alt={description || 'About'}
              objectFit="contain"
              width={1200}
            />
          )}
        </div>
      </Wrapper>
    </Container>
  );
};

export default AboutBlock;
